import React, { Component } from "react";
import Translate from "../translations/Translate";
import translateFunc from "../translations/TranslateFunction";

class FormEntry extends Component {
  render() {
    const placeHolder = translateFunc(
      this.props.value,
      "submitbox.copy-and-paste",
    );

    const optionalPlaceHolder = translateFunc(
      this.props.value,
      "fare.optional",
    );

    const {
      setInput,
      input,
      fare,
      tax,
      fee,
      fareCurrency,
      pasteIntoBox,
      adtQty,
    } = this.props;

    return (
      <div className="input-holder modern-entry">
        <div className="inputArea">
          <div className="pnr-input-wrapper">
            <textarea
              className="dataInputChildBox pnr-input"
              name="input"
              cols="30"
              rows="10"
              placeholder={placeHolder}
              value={input}
              onChange={setInput}
              onPaste={pasteIntoBox}
            />

            <button className="floating-convert-button" type="submit">
              <span>
                <Translate string="submitbox.convert" />
              </span>
              <img
                src="/images/icons/paper-plane.svg"
                alt=""
                aria-hidden="true"
              />
            </button>
          </div>
        </div>

        <div className="financials">
          <label htmlFor="currency-box" className="field-label currency-field">
            <p>Currency:</p>
            <select
              id="currency-box"
              name="fareCurrency"
              onChange={setInput}
              value={fareCurrency}
            >
              <option value="$">$</option>
              <option value="£">£</option>
              <option value="€">€</option>
              <option value="CA$">CA$</option>
              <option value="CHF">CHF</option>
              <option value="ft">ft</option>
              <option value="HK$">HK$</option>
              <option value="kr">kr</option>
              <option value="kn">kn</option>
              <option value="Ksh">Ksh</option>
              <option value="lei">lei</option>
              <option value="QAR">QAR</option>
              <option value="R">R</option>
              <option value="RM">RM</option>
              <option value="Rp">Rp</option>
              <option value="Rs">Rs</option>
              <option value="R$">R$</option>
              <option value="S/.">S/.</option>
              <option value="zł">zł</option>
              <option value="¥">¥</option>
              <option value="₾">₾</option>
              <option value="₽">₽</option>
              <option value="₺">₺</option>
              <option value="₴">₴</option>
              <option value="₪">₪</option>
              <option value=".د.م">.د.م</option>
              <option value="₦">₦</option>
              <option value="₹">₹</option>
              <option value="₱">₱</option>
              <option value="₩">₩</option>
              <option value="฿">฿</option>
              <option value="₫">₫</option>
            </select>
          </label>

          <div className="fare-inputs">
            <label htmlFor="fare-box" className="field-label fare-field">
              <p>
                <Translate string="fare.fare" />:
              </p>

              <div className="fare-with-qty">
                <select
                  name="adtQty"
                  id="adt-fare-qty"
                  value={adtQty}
                  onChange={setInput}
                >
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                  <option value="7">7</option>
                  <option value="8">8</option>
                </select>

                <input
                  placeholder={optionalPlaceHolder}
                  value={fare}
                  name="fare"
                  type="text"
                  onChange={setInput}
                  id="fare-box"
                />
              </div>
            </label>

            <label htmlFor="tax-box" className="field-label">
              <p>
                <Translate string="fare.tax" />:
              </p>
              <input
                placeholder={optionalPlaceHolder}
                value={tax}
                name="tax"
                type="text"
                id="tax-box"
                onChange={setInput}
              />
            </label>

            <label htmlFor="fee-box" className="field-label">
              <p>
                <Translate string="fare.fee" />:
              </p>
              <input
                placeholder={optionalPlaceHolder}
                value={fee}
                name="fee"
                type="text"
                id="fee-box"
                onChange={setInput}
              />
            </label>
          </div>
        </div>
      </div>
    );
  }
}

export default FormEntry;
